// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-hydrant-map-items-list-request-schema',
  type: 'object',
  required: ['fireDepartmentId'],
  properties: {
    fireDepartmentId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
